import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-support-sso',
  templateUrl: './support-sso.component.html',
  styleUrls: ['./support-sso.component.scss']
})
export class SupportSsoComponent implements OnInit {

  constructor(private route: ActivatedRoute, private userService: UserService) {
    this.route.queryParams.subscribe(params => {
      this.userService.getZendeskJWTToken().subscribe((r) => {

        let newLocation = `https://ecodocssolutions.zendesk.com/access/jwt?jwt=${r.jwt}`;
        if (params.return_to) {
          newLocation += `&return_to=${encodeURIComponent(params.return_to)}`;
        }

        location.href = newLocation;
      }, () => {
        this.userService.logout();
      })
    });
  }

  ngOnInit(): void {
  }

}
